class HumanReadableIdManager {
  constructor() {
    this.idPairs = {};
    this.nextId = 0;
  }

  getId = oId => {
    const idToReturn = this.idPairs[oId];
    if (!idToReturn) {
      this.idPairs[oId] = this.nextId;
      this.nextId = this.nextId + 1;
    }

    return this.idPairs[oId];
  };
}

export const humanReadableIdManager = new HumanReadableIdManager();
